// Builds a vCard 3.0 string from a user's profile so QR scanners offer "Add to Contacts".
function esc(v) {
  return String(v || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
}

export function buildVCard({ name, email, profile }) {
  const p = profile || {};
  const full = (name || "").trim();
  const parts = full.split(/\s+/);
  const first = parts.shift() || "";
  const last = parts.join(" ");
  const workEmail = p.work_email || email || "";
  const lines = ["BEGIN:VCARD", "VERSION:3.0", `N:${esc(last)};${esc(first)};;;`, `FN:${esc(full)}`];
  if (p.company || p.department) lines.push(`ORG:${esc(p.company)}${p.department ? ";" + esc(p.department) : ""}`);
  if (p.title) lines.push(`TITLE:${esc(p.title)}`);
  if (p.phone) lines.push(`TEL;TYPE=WORK,VOICE:${esc(p.phone)}`);
  if (workEmail) lines.push(`EMAIL;TYPE=WORK:${esc(workEmail)}`);
  if (p.website) lines.push(`URL:${esc(p.website)}`);
  if (p.linkedin) lines.push(`URL:${esc(p.linkedin)}`);
  if (p.address) lines.push(`ADR;TYPE=WORK:;;${esc(p.address)};;;;`);
  lines.push("END:VCARD");
  return lines.join("\r\n");
}

export function downloadVCard(vcardStr, filename = "contact.vcf") {
  const blob = new Blob([vcardStr], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// One-tap share via the native share sheet, with a download fallback.
export async function shareVCard({ name, email, profile }) {
  const vcard = buildVCard({ name, email, profile });
  const filename = `${(name || "contact").replace(/\s+/g, "_")}.vcf`;
  const title = `${name || "Contact"} — business card`;
  try {
    const file = new File([vcard], filename, { type: "text/vcard" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title });
      return "shared";
    }
    if (navigator.share) {
      await navigator.share({ title, text: vcard });
      return "shared";
    }
  } catch (e) {
    if (e && e.name === "AbortError") return "cancelled";
  }
  downloadVCard(vcard, filename);
  return "downloaded";
}
